import React, { useState, useEffect, useRef } from "react";

import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import Button from "../button/button";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

// Select componentreact-select
export default function Search({
  onInput,
  value = [],
  search = false,
  options = [],
  suggested = true,
  multi = false,
  name = "",
  placeholder = "",
  getChange,
  menuHeight = 200,
  onSearch,
  clearFilter,
  isSearchPage,
  autoFocus,
  components
}) {
  const searchInput = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [openMenu, setOpenMenu] = useState(false);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: search ? "auto" : "170px",
      height: search && "55px",
      backgroundColor: "#Fff",
      padding: "3px",
      borderColor: "#0B5FFF",
      borderRadius: "5px",
      ":hover": {
        borderColor: suggested ? "#0B5FFF" : "black",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      // backgroundColor: (profileBuilding || technical ) ? '#F1F2F5' : '#fff',
      // marginLeft: profileBuilding && 1,
      // border : '0.5px solid #0B5FFF',
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "#6B6C7E",
      fontSize: "16px",
    }),
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: suggested ? "#0B5FFF" : "#fff",
        color: suggested ? "white" : "black",
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: "text-white-1",
      fontSize: suggested ? "16px" : "18px",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: suggested ? "white" : "black",
      clearableValue: true,
      ":hover": {
        color: "black",
      },
    }),
    indicatorSeparator: () => {}, // removes the "stick"
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      marginRight: "5px",
    }),
  };

  const handleOnChange = (data, action) => {
    var check =
      data.length > 0 ? options.some((l) => l["label"] == data[0].label) : true;
    // If multi select
    // if(multi){
    var array = [];
    data.map((d) => array.push(d));
    // Function to handle onChange
    getChange(array, true, action);
    // }
    // else{
    //   // Function to handle onChange
    //   getChange(data);
    // }
  };

  const handleInputChange = (data) => {
    setInputValue(data);
  };

  const onButtonClick = () => {
    var array = [];
    if (value.length) {
      array = value.map((s) => s.label);
    }
    if (inputValue) {
      array.push(inputValue);
    }
    onSearch(array.toString());
    isSearchPage && clearFilter("clearAll");
  };

  const keyDown = (e) => {
    setOpenMenu(true);
    var myObj = {
      value: inputValue,
      label: inputValue,
    };
    // on enter key pressed (search)
    if (e.keyCode === 13) {
      e.preventDefault();
      var array = [];
      if (value?.length) {
        array = value.map((s) => s.label);
      }
      if (myObj.value) {
        //inputfield should not be empty
        let teamArrayObject = value || [];
        getChange([...teamArrayObject, myObj], true);
        array.push(myObj.value);
        setInputValue("");
      }
      setOpenMenu(false);
      // let teamArrayObject = value || [];
      // getChange([...teamArrayObject, myObj], true);
      onSearch(array.toString());
      isSearchPage && clearFilter("clearAll");
    }
    // on space key pressed (don't make the tag)
    else if (e.keyCode === 32) {
      e.preventDefault();
      var str = inputValue.concat(" ");
      setInputValue(str);
    }
    // on comma key pressed (make the tag)
    else if (e.keyCode === 188) {
      e.preventDefault();
      if (myObj.value) {
        //inputfield should not be empty
        let teamArrayObject = value || [];
        getChange([...teamArrayObject, myObj], true);
        setInputValue("");
        // setOpenMenu(false);
      }
    }
  };

  const handleOnBlurChange = (e) => {
    e.preventDefault();
    if (inputValue) {
      var myObj = {
        value: inputValue,
        label: inputValue,
      };
      var array = value || [];
      array.push(myObj);
      getChange(array, true);
      setInputValue("");
      
    }
    setOpenMenu(false);
  };

  // const icon = (
  //   <SearchRoundedIcon
  //     color="action"
  //     fontSize="large"
  //     style={{ paddingLeft: "10px" }}
  //   />
  // );
  // const Control = ({ children, ...props }) => (
  //   <components.Control {...props}>
  //     {" "}
  //     {icon} {children}
  //   </components.Control>
  // );
  const handleFocus = (event) => {
    setOpenMenu(true);
  };

  return (
    <div className="flex col-span-12 grid grid-cols-12 gap-3">
      <div className="col-span-12">
        <CreatableSelect
          formatCreateLabel={(userInput) => `Search for ${userInput}`}
          styles={colourStyles}
          name={name}
          value={value}
          inputValue={inputValue}
          className={`w-full`}
          closeMenuOnSelect={true}
          isMulti={true}
          placeholder={placeholder}
          options={options}
          maxMenuHeight={menuHeight}
          onChange={handleOnChange}
          onInputChange={handleInputChange}
          menuIsOpen={openMenu}
          // backspaceRemovesValue= {suggested ? true : false}
          onKeyDown={keyDown}
          onBlur={handleOnBlurChange}
          onFocus={handleFocus}
        
          // components={{ Control }}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
      {/* <div className="col-span-2">
        <Button
          buttonType="primary-2"
          value="Search"
          onClick={onButtonClick}
          name={name}
        />
      </div> */}
    </div>
  );
}
